<template>
  <div></div>
</template>
<script>
import { mapGetters } from 'vuex'
import FN from '@/utility/fn.js'
import PS from 'pubsub-js'
import '@/fuse/fuse.sdk'
export default {
  data () {
    return {
      ifram: this.$store.state.SDKComponent.iframe
    }
  },
  computed: {
    ...mapGetters(['SDKComponentMessage'])
  },
  methods: {
    spread() {
      window.FUSESDKAPI.spread({
        token,
        data,
        callback(data = {}) {

        }
      })
    }
  },
  mounted () {
    this.spread()
  }
}
</script>
